import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=997bbd46&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=997bbd46&prod&lang=sass&scoped=true"
import style1 from "./Summary.vue?vue&type=style&index=1&id=997bbd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997bbd46",
  null
  
)

export default component.exports